<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import Header from '@components/header.vue'
import retrievePhoneByRole from '@utils/retrieve-phone-by-role'
import { store } from '../../state/store'

export default {
  page: {
    title: 'Help',
    description: { name: 'description', content: appConfig.description },
  },
  components: { Layout, Header },
  data() {
    return {
      state: store.state,
      appReleaseName: '#{APP_RELEASE_NAME}#',
    }
  },
  methods: {
    retrievePhoneByRole() {
      return retrievePhoneByRole()
    },
  },
}
</script>

<template>
  <Layout>
    <Header />
    <div :class="$style.help_container">
      <h1 :class="$style.header">Help</h1>
      <div :class="$style.help_message"
        >If you need help completing this job, please call
        <a :class="$style.phone_link" :href="'tel:' + retrievePhoneByRole()">{{
          retrievePhoneByRole()
        }}</a>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.help_container {
  max-width: $size-parent-container-width-max;
  padding: 1em;
  margin: auto;
  text-align: center;
  top: $height-status-bar;
  position: relative;
}

.header {
  color: $color-text-primary;
  font-weight: 900;
  margin-top: 0;
}

.help_message {
  font-weight: bold;
  padding: 0 1em;
  margin-bottom: 5em;
}

.app_version {
  margin: auto;
}

.phone_link {
  color: $color-text-primary;
  text-decoration: underline;
}
</style>
